/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import { ReactComponent as EyeIcon } from "cms/assets/icons/eye-regular-preview.svg";
import { CmsConfig } from "cms/config";
import { Logger } from "cms/utils/logger";
import { removeCookie } from "cms/auth/cookie";
import { useSimpliCityComposer } from "@simplicitycms/simplicity-common";
import { ReactComponent as SimpliCityIcon } from "cms/assets/icons/simplicity-icon-gray.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PreviewBanner = (props) => {

    const { children } = props;
    // Urls for editor preview and live
    const { editor } = useSimpliCityComposer();

    const environment_name = `${CmsConfig.Environment.Name}`;
    // eslint-disable-next-line no-unused-vars
    const logout = () => {
        Logger.info("logout taking place");
        removeCookie("simplicity_admin", { path: "/", domain: CmsConfig.COOKIE_DOMAIN });
        removeCookie("simplicity_refresh", { path: "/", domain: CmsConfig.COOKIE_DOMAIN });
        localStorage.removeItem("simplicity_refresh");
        const url = `${CmsConfig.LOGOUT_URL}`;
        Logger.info(`Logout: ${url}`);
        window.location.replace(url);
    };
    const onLogout = (event) => {
        event.preventDefault();
        logout();
    };

    return (
        <>
            <div className='bannerContainer'>
                <div className='leftContent'>
                    <SimpliCityIcon className='bannerIcon' />
                    <span className="environment-label"> [{environment_name}] </span>
                    <EyeIcon className='bannerIcon' />
                    <span>Preview</span>
                </div>
                <div className='rightContent'>
                    {editor && (
                        <Button
                            variant="text"
                            size="small"
                            href={editor}
                            target={"_blank"}
                            className='editButton'
                            startIcon={<FontAwesomeIcon icon="fa-regular fa-pen-to-square" />}
                        >
                            Edit
                        </Button>
                    )}
                    <Button
                        variant="text"
                        size="small"
                        onClick={onLogout}
                    >
                        Logout
                    </Button>
                </div>
            </div>
            {children}
        </>
    );
};

export { PreviewBanner };
